import { __decorate } from "tslib";
import { LitElement, html } from 'lit';
import { property } from 'lit/decorators.js';
import { styleMap } from 'lit/directives/style-map.js';
import { emit } from '@amityeko/pbc-core/dist/utilities/event';
import chevronUpIcon from '../../assets/icons/chevron-up';
import chevronDownIcon from '../../assets/icons/chevron-down';
import '../avatar';
import '../typography/tg-body-one';
import '../icon';
import styles from './styles';
/**
 * @dependency amityeko-avatar
 * @dependency amityeko-tg-body-one
 * @dependency amityeko-icon
 *
 * @slot content - The accordion-item's content
 *
 * @csspart header - The accordion-item's header container.
 * @csspart content - The accordion-item's content container
 */
export default class AmityekoAccordionItem extends LitElement {
    constructor() {
        super(...arguments);
        this.isOpen = false;
        this.image = '';
        this.label = '';
    }
    _onClick() {
        emit(this, 'amityeko-select-accordion-item');
        this.isOpen = !this.isOpen;
    }
    render() {
        return html `
      <div part="header" class="header" @click=${this._onClick}>
        <div class="header__info">
          <amityeko-avatar shape="circle" image=${this.image}></amityeko-avatar>
          <amityeko-tg-body-one>${this.label}</amityeko-tg-body-one>
        </div>
        <amityeko-icon .iconSize=${'10px'} color="#757575"
          >${this.isOpen ? chevronUpIcon : chevronDownIcon}</amityeko-icon
        >
      </div>
      <div
        class="content"
        part="content"
        style=${styleMap({
            '--private-opacity': this.isOpen ? '1' : '0',
        })}
      >
        ${this.isOpen ? html `<slot name="content"></slot>` : null}
      </div>
    `;
    }
}
AmityekoAccordionItem.styles = styles;
__decorate([
    property({ type: Boolean })
], AmityekoAccordionItem.prototype, "isOpen", void 0);
__decorate([
    property()
], AmityekoAccordionItem.prototype, "image", void 0);
__decorate([
    property()
], AmityekoAccordionItem.prototype, "label", void 0);
if (!customElements.get('amityeko-accordion-item')) {
    customElements.define('amityeko-accordion-item', AmityekoAccordionItem);
}
//# sourceMappingURL=index.js.map